import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import vueMoment from "vue-moment";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import config from "@/config";
import wait from "@/wait";
import { ValidationProvider } from 'vee-validate';
import "@/common/title";
import "@/common/filters";
import "@/common/constants";
import "@/logging";
import "@/service";
import "@/style/main.scss";

Vue.component('ValidationProvider', ValidationProvider);

Vue.prototype.$config = config;

Vue.use(BootstrapVue, vueMoment);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  wait,
  render: h => h(App)
}).$mount("#app");

Vue.config.devtools = process.env.NODE_ENV !== "production";